<mat-card appearance="outlined">
  <mat-card-header class="justify-content-between align-items-center mb-3">
    <mat-card-title class="fs-5 mb-0">
      City specific data
    </mat-card-title>
    <button mat-button color="primary" [routerLink]="['/dashboard','countries']" [skipLocationChange]="true">See more</button>
  </mat-card-header>
  <div class="rounded-3 bg-light">
    <sm-data-table [columnHeaders]="tableDisplayColumn" [dataSource]="citySpecificData"></sm-data-table>
  </div>
</mat-card>
